// web_common_user_roleTypeEnumList
const __request = require(`@/lib/data-service/default/__request/__request_contentType_json`);

export default function web_common_user_roleTypeEnumList(pParameter) {
    let params = {}
    if (!pParameter) pParameter = {};
    params.method = 'POST'
    params.urlSuffix = '/web/common/user/roleTypeEnumList'
    params.data = pParameter
    return new Promise(function(resolve, reject) {
        resolve(__request(params))
    })
}
